import React, { useLayoutEffect, useState, useRef } from 'react';
import reverse from 'lodash/reverse';
import PropTypes from 'prop-types';

import styles from './WithMiddleEllipses/styles.module.scss';

const renderText = (text, isTextOverflowing) => {
  if (!text) {
    return '';
  }

  if (isTextOverflowing) {
    const reversed = reverse(text.split('')).join('');
    return (
      <div className={styles.withMiddleEllipses}>
        <span className={styles.text}>{text}</span>
        <span aria-hidden="true" className={styles.ellipses}>
          ...
        </span>
        <span aria-hidden="true" className={styles.text}>
          {reversed}
        </span>
      </div>
    );
  } else {
    return <div className={styles.withMiddleEllipses}>{text}</div>;
  }
};

export const WithMiddleEllipses = (props) => {
  const { className, text: _text } = props;
  const [isTextOverflowing, setIsTextOverflowing] = useState(0);
  const [height, setHeight] = useState(0);
  const [text, setText] = useState('');
  const _this = useRef(null);

  useLayoutEffect(() => {
    setHeight(0);
    setIsTextOverflowing(0);
    setText(_text);
  }, [_text]);

  useLayoutEffect(() => {
    if (_this.current) {
      const nameNode = _this.current.querySelector(`.${styles.withMiddleEllipses}`);
      if (nameNode) {
        const isOverflowing = nameNode.offsetWidth < nameNode.scrollWidth;

        if (isOverflowing) {
          setIsTextOverflowing((txtOverflow) => (txtOverflow += 1));
        } else {
          setIsTextOverflowing(0);
        }
      }
    }
  }, [text]);

  useLayoutEffect(() => {
    if (isTextOverflowing) {
      const nameNode = _this.current.querySelector(`.${styles.withMiddleEllipses}`);
      setHeight(nameNode.clientHeight);
    } else {
      setHeight(0);
    }
  }, [isTextOverflowing]);

  return (
    <div
      ref={_this}
      style={isTextOverflowing && height ? { height: `${height}px` } : {}}
      className={`${styles.wrapper} ${className || ''} ${
        !isTextOverflowing || !height ? styles.noWrap : ''
      }`}
    >
      {renderText(text, isTextOverflowing)}
    </div>
  );
};

WithMiddleEllipses.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};
